<template>
    <section id="subscriptionDiv">
        <div class="container mt-5">
            <div class="px-4 py-5 px-md-5 text-center text-lg-start">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <img class="pt-7 pt-md-0 hero-img" src="../../assets/img/reg.png">
                            <h1 class="my-5 display-3 fw-bold ls-tight">
                                Choose Your <br />
                                <span class="text-primary">Subscription Package</span>
                            </h1>
                            <p style="color: hsl(217, 10%, 50.8%)">
                                Explore our subscription packages tailored for your needs. Choose the best package and
                                unlock exclusive benefits for your business.
                            </p>
                        </div>

                        <div class="col-lg-6">
                            <div class="card shadow-lg" style="background-color: #ffffff; border-radius: 15px;">
                                <div class="card-body py-5 px-md-5">
                                    <h3 class="mb-4 text-center text-uppercase fw-bold text-primary">
                                        Choose Your Plan
                                    </h3>
                                    <div v-if="packages.length > 0" class="row gy-4">
                                        <!-- Package Card -->
                                        <div v-for="(pkg, index) in packages" :key="index"
                                            class="col-md-12 col-lg-12 d-flex align-items-stretch">
                                            <div class="package-card p-4 border rounded shadow-sm w-100">
                                                <h4 class="text-secondary text-uppercase fw-bold text-center">
                                                    {{ pkg.name }}
                                                </h4>
                                                <p class="text-center fs-5">
                                                    <strong class="text-primary">${{ pkg.price }}</strong> / month
                                                </p>
                                                <div class="d-flex justify-content-center">
                                                    <button class=" col-12 btn btn-primary btn-lg text-uppercase px-4 mt-3"
                                                        @click="goToPlanDetails(pkg)">
                                                        Select Plan
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="text-center">
                                        <p class="text-muted fs-5">No packages available at the moment.</p>
                                    </div>
                                    <div class="alert alert-danger mt-3" v-if="error">
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import $ from 'jquery';

export default {
    name: 'SubscriptionPage',
    data() {
        return {
            packages: [], // Holds fetched packages
            error: null,  // Holds error messages
        };
    },
    mounted() {
        this.fetchPackages();
        
    },
    methods: {
         // Navigate to the plan details page
         goToPlanDetails(pkg) {
            this.$router.push({
                path: '/package-view',
                query: { name: pkg.name, price: pkg.price }
            });
        },
        fetchPackages() {
            const apiUrl = process.env.VUE_APP_API_URL +'/getEnablePackages';
            $.ajax({
                url: apiUrl,
                method: 'GET',
                success: (response) => {
                    this.packages = response;
                },
                error: (xhr) => {
                    this.error = 'Error fetching packages. Please try again later.';
                    console.error(xhr.responseJSON.message);
                },
            });
        },
        selectPackage(pkg) {
            alert(`You have selected the ${pkg.name} package.`);
            // Add logic for handling package selection
        },
    },
};
</script>

<style scoped>
.card {
    border: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.package-card {
    background: #f8f9fa;
    transition: transform 0.3s, box-shadow 0.3s;
}

.package-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
}

h4 {
    color: #5a5a5a;
}

button {
    background-color: #37a2d3;
    border: none;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #bd0606;
    color: #ffffff;
}

.alert {
    font-size: 0.9rem;
}

.text-primary {
    color: #bd0606 !important;
}
</style>
